import {Tr} from "@/i18n/i18n";
import {injectable} from "inversify";
import {ClanInfo, ClanmanInfo, ClanShortInfo, InvitationDto} from "@/store/clan/types";
import {ClanParticipationState, Player} from "@/store/player/types";
import Scene = Phaser.Scene;
import {ClanIntroPanel} from "@/scenes.ui.clan/clan-intro-panel";
import {Settings} from "@/constants/settings";
import {ClanStartPanel} from "@/scenes.ui.clan/clan-start-panel";
import CU from "../utils/c-u";
import ListenerManager from "@/managers/listener-manager";
import {ClanMemberPanel} from "@/scenes.ui.clan/clan-member-panel";
import Container = Phaser.GameObjects.Container;
import {FeedbackPanel} from "@/scenes.ui/feedback-panel";
import {ClanRatingPanel} from "@/scenes.ui.clan/clan-rating-panel";
import {ClanDetailsPanel} from "@/scenes.ui.clan/clan-details-panel";
import ClanStore from "@/store/clan";
import PlayerStore from "@/store/player";
import {SceneService} from "@/services/scene-service";
import Graphics = Phaser.GameObjects.Graphics;
import {ForumService} from "@/services/forum-service";
import {ListService} from "@/services/list-service";
import SpriteUtils from "@/utils/sprite-utils";
import {Keys} from "@/constants/key";
import Sprite = Phaser.GameObjects.Sprite;
import Group = Phaser.GameObjects.Group;
import OnceCaller from "@/utils/once-caller";
import {InputTextPanel} from "@/scenes.ui/input-text-panel";

@injectable()
export class ClanService {

    private clanSceneCallback!: () => unknown;
    private noMoneyCallback!: () => void;
    private onRatingCallback!: () => void;
    private player!: Player;

    private forumService!: ForumService;
    private listService!: ListService;

    public openClan(scene: Scene, canvas: HTMLCanvasElement,
                    clanSceneCallback: () => unknown,
                    clanSceneInstCallback: () => unknown,
                    roadSceneInstCallback: () => unknown,
                    sceneService: SceneService,
                    forumService: ForumService,
                    listService: ListService,
                    noMoneyCallback: () => void, onRatingCallback: () => void): void {
        this.clanSceneCallback = clanSceneCallback;
        this.noMoneyCallback = noMoneyCallback;
        this.onRatingCallback = onRatingCallback;
        this.forumService = forumService;
        this.listService = listService;
        this.player = PlayerStore.getPlayer()!;

        let self = this;
        if (this.player.clanParticipationState === ClanParticipationState.ACCEPTED_TO_CLAN || this.player.clanParticipationState === ClanParticipationState.CLAN_MEMBER) {
            let faded: boolean = false;
            let responseRecieved: boolean = false;
            let back: {group: Group, graphics:Graphics} | Graphics | undefined = sceneService.fadeInClouds(scene, canvas, canvas.width, canvas.height, () => {
                faded = true;

                if (responseRecieved) {
                    clanSceneInstCallback();
                }
            }, 0, "clanScene");

            ClanStore.fetchMyClan().then((ci: ClanInfo | undefined) => {
                if (ci) {
                    responseRecieved = true;

                    if (faded) {
                        clanSceneInstCallback();
                    }
                } else {
                    if (back && back instanceof Graphics) {
                        sceneService.cancelBackground( back);
                    } else if (back){
                        sceneService.cancelClouds(back);
                    }
                    self.fetchInvitation(scene, canvas, clanSceneCallback, noMoneyCallback, onRatingCallback);
                }
            });
        } else {
            self.fetchInvitation(scene, canvas, clanSceneCallback, noMoneyCallback, onRatingCallback);
        }
    }

    private fetchInvitation(scene: Scene, canvas: HTMLCanvasElement, clanSceneCallback: () => unknown, noMoneyCallback: () => void, onRatingCallback: () => void) {
        ClanStore.fetchClanInvitation().then((inv: InvitationDto) => {
            if (inv.clanParticipationState === ClanParticipationState.ACCEPTED_TO_CLAN) {
                ClanStore.fetchMyClan().then(() => {
                    clanSceneCallback();
                });
            } else if (inv.clanParticipationState === ClanParticipationState.CLAN_MEMBER) {
                ClanStore.fetchMyClan().then(() => {
                    clanSceneCallback();
                });
            } else if (inv.clanParticipationState === ClanParticipationState.NOT_ENLIGHTENED) {
                let available = this.player.level >= Settings.CLAN_MIN_LEVEL
                let clanIntroPanel: ClanIntroPanel = new ClanIntroPanel(scene, canvas, available, () => {
                    ClanStore.applyClanBroadcast();
                    this.openStartPanel(scene, canvas, inv);
                });
                clanIntroPanel.openAnimated();
            } else if (inv.clanParticipationState === ClanParticipationState.AVAILABLE) {
                this.openStartPanel(scene, canvas, inv);
            } else if (inv.clanParticipationState === ClanParticipationState.NOT_AVAILABLE && inv.invitingClans && inv.invitingClans.length > 0) {
                this.openStartPanel(scene, canvas, inv);
            }
        });
    }

    public openClanRating(scene: Scene, canvas: HTMLCanvasElement, listViewCallback: (title: string, children: Container[]) => void,
                          memberCallback: (clanmanInfo: ClanmanInfo) => unknown, profileCallback: (playerId: number, parentViewId: string) => unknown) {
        CU.blockCanvas(scene!);
        ListenerManager.callClanRatingCallback();
        //
        // let self = this;
        // ClanStore.fetchClanRating().then((csi: ClanShortInfo[]) => {
        //   let clans: ClanRatingPanel[] = [];
        //   csi.forEach(cs => {
        //     let clanRatingPanel = new ClanRatingPanel(scene, cs, (ci: ClanShortInfo) => {
        //         this.showClanDetailsPanel(scene, ci, listViewCallback, memberCallback, profileCallback);
        //     });
        //     clans.push(clanRatingPanel);
        //   });
        //   listViewCallback(Tr('reyting.klanov'), clans);
        // });
    }

    public showClanDetailsPanel(scene: Scene, canvas: HTMLCanvasElement, ci: ClanShortInfo, listViewCallback: (title: string, children: Container[]) => void,
                                memberCallback: (clanmanInfo: ClanmanInfo) => unknown, profileCallback: (playerId: number, parentViewId: string) => unknown){
        let player: Player = PlayerStore.getPlayer()!;
        let self = this;

        let cdp: ClanDetailsPanel = new ClanDetailsPanel(scene, scene.sys.game.canvas, ci, () => {
            self.showClanMembersPage(scene, listViewCallback, memberCallback, ci.id);
        }, !player.clanId ? (() => {
            ClanStore.applyClan(ci.id);
            new FeedbackPanel(scene, Tr('zajavka.na.vstuplenie.v.klan.podana'), undefined, true).show();
        }) : undefined, () => {
            this.forumService.openForum(scene, scene.game.canvas, self.listService, undefined, undefined,
                ci.id, (playerId: number) => {
                    profileCallback(playerId, Tr('reyting.klanov'));
                });
        }, () => {
            OnceCaller.doOnce("clanRenamePanel", () => {
                let textPanel: InputTextPanel = new InputTextPanel(scene, canvas, Tr('change').toUpperCase() + " " + Tr('clan.name').toUpperCase(),  "",
                    Tr('clan.name'), Tr('publish'),  ci.name, (newName: string) => {
                        textPanel.closePanel();
                        ClanStore.setClanName(ci.id, newName).then(() => {
                            new FeedbackPanel(scene, Tr('izmeneno'), undefined, true).show();
                        });
                    });
                textPanel.openAnimated();
            });
        });
        cdp.openAnimated();
        cdp.setDepth(16000);
    }

    private showClanMembersPage(scene: Scene, listViewCallback: (title: string, children: Container[]) => void,
                                memberCallback: (clanmanInfo: ClanmanInfo) => unknown, clanId: number) {
        ClanStore.fetchMembersByClanId(clanId).then((cis: ClanmanInfo[]) => {

            let members: ClanMemberPanel[] = [];
            cis.forEach(ci => {
                let cmp: ClanMemberPanel = new ClanMemberPanel(scene, ci, (clanmanInfo: ClanmanInfo) => {
                    memberCallback(clanmanInfo);
                });
                members.push(cmp);
            });
            if (listViewCallback != null) {
                listViewCallback(Tr('uchastniki'), members);
            }
        });
    }

    private openStartPanel(scene: Scene, canvas: HTMLCanvasElement, inv: InvitationDto) {
        let self = this;
        let clanStartPanel: ClanStartPanel = new ClanStartPanel(scene, canvas, inv,
            (clanId: number) => {
                ClanStore.acceptClanInvitation(clanId).then(() => {
                    self.clanSceneCallback();
                });
            },
            () => {
                if (this.onRatingCallback != null) {
                    this.onRatingCallback();
                }
            },
            () => {
                if (inv.clanCreationPrice <= this.player.mithril){
                    CU.blockCanvas(scene!);
                    if (this.clanSceneCallback != null) {
                        ListenerManager.setClanCreationCallback(this.clanSceneCallback);
                    }
                    ListenerManager.callClanNamePageOpenCallback();
                } else {
                    if (this.noMoneyCallback != null) {
                        this.noMoneyCallback();
                    }
                }
        });
        clanStartPanel.openAnimated();
    }




}
